import React from 'react'

import { connect } from 'react-redux'
import GoogleMapReact from 'google-map-react'
import CircularProgress from 'material-ui/CircularProgress'

import Pin from './Pin'

class MapView extends React.PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      childHovered: '',
      position: null
    }
    this.cache = {}
  }

  componentWillMount() {
    if (this.props.userLocation
        && this.props.userLocation.lat
        && this.props.userLocation.lng){
      this.updatePosition(this.props.userLocation)
    } else {
      //notify LocationManager
      this.props.dispatch({
        type: 'UI_DIALOG',
        label: 'GET_LOCATION',
        value: 'grant'
      })
    }
  }

  componentWillReceiveProps(nextProps){
    if (this.props.userLocation !== nextProps.userLocation){
      this.updatePosition(nextProps.userLocation)
    }
  }

  updatePosition = (position) => {
    this.setState({ position })
  }

  onChildMouseEnter = (key, child) => {
    const childHovered = child.eventId
    this.setState({ childHovered })
  }

  onChildMouseLeave = (key, child) => {
    if (child.eventId === this.state.childHovered){
      this.setState({ childHovered: '' })
    }
  }

  onChildClick = (key, child) => {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'JOB_SCREEN',
      value: {
        jobInfo: child.eventInfo.commonInfo,
        dateStr: this.props.dateStr
      }
    })
  }

  getLatAndLong = (eventInfo) => {
    const commonInfo = eventInfo.commonInfo.modules
    if (commonInfo.address.lat
        && commonInfo.address.lng){
          return {
            lat: commonInfo.address.lat,
            lng: commonInfo.address.lng
          }
        } else {
          return {}
        }
  }

  getNextPoint = (lat, lng) => {
    //add jitter
    let newLat = lat
    let newLng = lng
    //TODO order in a spiral form
    while (this.cache[newLat]
           && this.cache[newLat][newLng]){
      newLat+= 0.0001
    }
    return { newLat, newLng }
  }

  resolveSimilarPoints = (lat, lng) => {
    if (!this.cache[lat]){
      this.cache[lat] = {}
      this.cache[lat][lng] = true
      return { lat, lng }
    } else if (!this.cache[lat][lng]){
      this.cache[lat][lng] = true
      return { lat, lng }
    } else if (this.cache[lat][lng]){
      const {newLat, newLng} = this.getNextPoint(lat, lng)
      if (!this.cache[newLat]){
        this.cache[newLat] = {}
      }
      this.cache[newLat][newLng] = true
      return {
        lat : newLat,
        lng : newLng
      }
    }
  }

  renderPins() {
    this.cache = {}
    const allIds = Object.keys(this.props.eventIds)
    return allIds.map((eventId, index) => {
      const { lat, lng } = this.getLatAndLong(this.props.eventInfos[eventId])
      const resolvedPoints = this.resolveSimilarPoints(lat, lng)
      return (
        <Pin
          key={index}
          lat={resolvedPoints.lat}
          lng={resolvedPoints.lng}
          eventInfo={this.props.eventInfos[eventId]}
          hover={this.state.childHovered === eventId}
          text={`Event ${index}`}
          eventId={eventId}
          dateStr={this.props.dateStr}
        />
      )
    })
  }

  render() {
    if (this.state.position) {
      return (
        <div style={styles.container}>
          <GoogleMapReact
            defaultCenter={this.state.position}
            defaultZoom={12}
            onChildMouseEnter={this.onChildMouseEnter}
            onChildMouseLeave={this.onChildMouseLeave}
            onChildClick={this.onChildClick}>
            {this.renderPins()}
          </GoogleMapReact>
        </div>
      )
    }
    return (
      <div style={styles.progress}>
        <CircularProgress size={60} thickness={2} />
      </div>
    )
  }
  
}

const styles = {
  container: {
    display: 'flex',
    flexGrow: 1
  },
  progress: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center'
  }
}

const mapStateToProps = state => ({
  instances: state.schedule.instances,
  userLocation: state.userSettings.location
})

export default connect(mapStateToProps)(MapView)



// WEBPACK FOOTER //
// ./src/schedule/map/MapView.js